// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"200","container":"af7b80","logo":"_83c329"};